const FilterStatus = {
    INVALID: -1,
    NEW: 0,
    VARIABLE_SELECTED: 1,
    VALID: 2,
    INACTIVE: 4,
};

export default FilterStatus;
